import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useFinaliseOrder = (order) => {
  return useQuery({
    queryKey: ["draftOrderFinalise", order],
    queryFn: async () =>
      callApi({
        path: "draftorderfinalise",
        command: "get",
        data: JSON.stringify({ data: { filter: { noFilter: order } } }),
      }),
  });
};
